import React from "react";
import { JSEncrypt } from "jsencrypt";
import moment from "moment";
import {
   CP_GAMIFICATION,
   HOPPY,
   ARI,
   BP2_CLOUD,
   BP2_CLOUD_QA,
   CZG,
   CZG_QA,
   PFLEGEPOWER,
   ETRACON,
   HOMEDEAL,
   GABINET,
} from "../constants/GlobalVariables";
import { TAB_SIZE } from "../constants/ThemeSetting";
import { editUserBoards } from "../appRedux/actions/User";
import {
   getTranslation,
   getUserWithBoards,
   postNewTranslation,
   editTranslations,
   getFile,
} from "../services/restAPI/RestApi";
import { store } from "../appRedux/store/Store";
import projectConfig from "@projectConfig";
import IntlMessages from "@util/IntlMessages";
import { decode, encode } from "js-base64";
import { setTranslations } from "../appRedux/actions/Translations";
import { setWidgetCache } from "../appRedux/actions/WidgetCache";
import { Message } from "../components/BP2Components";
import { setUserBoards } from "../appRedux/actions/Boards";
//Handling adding data/time to actual date
export const handleChangeData = (date, receivedValue) => {
   //handling data
   if (receivedValue !== "") {
      if (receivedValue !== undefined) {
         if (receivedValue.match(/([0-9]+)(?:Y)/)) {
            const result = receivedValue.match(/([0-9]+)(?:Y)/);
            //P === plus / M === minus
            if (receivedValue.match(/^([a-zA-Z])/)[0] === "P") {
               date = date.add(result[1], "year");
            } else if (receivedValue.match(/^([a-zA-Z])/)[0] === "M") {
               date = date.subtract(result[1], "year");
            }
         }
         if (receivedValue.match(/([0-9]+)(?:M)/)) {
            const result = receivedValue.match(/([0-9]+)(?:M)/);
            if (receivedValue.match(/^([a-zA-Z])/)[0] === "P") {
               date = date.add(result[1], "months");
            } else if (receivedValue.match(/^([a-zA-Z])/)[0] === "M") {
               date = date.subtract(result[1], "months");
            }
         }
         if (receivedValue.match(/([0-9]+)(?:D)/)) {
            const result = receivedValue.match(/([0-9]+)(?:D)/);
            if (receivedValue.match(/^([a-zA-Z])/)[0] === "P") {
               date = date.add(result[1], "days");
            } else if (receivedValue.match(/^([a-zA-Z])/)[0] === "M") {
               date = date.subtract(result[1], "days");
            }
         }
         //handling time
         if (receivedValue.match(/(?:T)(.*)/)) {
            if (receivedValue.match(/([0-9]+)(?:H)/)) {
               const result = receivedValue.match(/([0-9]+)(?:H)/);
               if (receivedValue.match(/^([a-zA-Z])/)[0] === "P") {
                  date = date.add(result[1], "hours");
               } else if (receivedValue.match(/^([a-zA-Z])/)[0] === "M") {
                  date = date.subtract(result[1], "hours");
               }
            }
            if (receivedValue.match(/([0-9]+)(?:M)/)) {
               const result = receivedValue.match(/([0-9]+)(?:M)/);
               if (receivedValue.match(/^([a-zA-Z])/)[0] === "P") {
                  date = date.add(result[1], "minutes");
               } else if (receivedValue.match(/^([a-zA-Z])/)[0] === "M") {
                  date = date.subtract(result[1], "minutes");
               }
            }
            if (receivedValue.match(/([0-9]+)(?:S)/)) {
               const result = receivedValue.match(/([0-9]+)(?:S)/);
               if (receivedValue.match(/^([a-zA-Z])/)[0] === "P") {
                  date = date.add(result[1], "seconds");
               } else if (receivedValue.match(/^([a-zA-Z])/)[0] === "M") {
                  date = date.subtract(result[1], "seconds");
               }
            }
         }
         return moment(date.format("YYYY-MM-DD HH:mm:ss"));
      }
   }
};
export function minutesTohHhmm(numberOfMinutes) {
   let duration = moment.duration(numberOfMinutes, "minutes");
   let hh =
      duration.years() * (365 * 24) +
      duration.months() * (30 * 24) +
      duration.days() * 24 +
      duration.hours();

   if (hh?.toString().length === 1) {
      hh = `0${hh}`;
   }
   let mm = duration.minutes();
   if (mm?.toString().length === 1) {
      mm = `0${mm}`;
   }
   return `${hh}:${mm}`;
}
const selectAntdRow = (tableClass, id) => {
   let rows = $("." + tableClass).find(".ant-table-row");
   rows.removeClass("gx-selected");
   if (rows.length > 0) {
      $(rows[id]).addClass("gx-selected");
   }
};
export default selectAntdRow;

export { isSafari } from "./browserUtils";

export function encryptMessage(message, publicKey) {
   const jsEncrypt = new JSEncrypt();
   jsEncrypt.setPublicKey(publicKey);
   return jsEncrypt.encrypt(message);
}

export function copyText(text) {
   var input = $('<input type="text">');
   input[0].setAttribute("value", text);
   $("body").append(input);
   input[0].select();
   input[0].setSelectionRange(0, 99999);
   document.execCommand("copy");
   input.remove();
}

//this function need`s a value of string
export function checkUrl(text) {
   const query = new URLSearchParams(window.location.search);
   if (query.get(text)) return true;
}
export function mobileStartActionByUrl(parameters) {
   try {
      if (window.mobileApp) {
         window.mobileApp.startActionByUrl(parameters);
      }
   } catch (error) {
      console.log(error);
   }
}
export function getDistanceFromLatLngInKm(currentPosition, marker) {
   const { lat: lat1, lng: lng1 } = currentPosition;
   const { lat: lat2, lng: lng2 } = marker;
   const deg2rad = (deg) => deg * (Math.PI / 180);
   var R = 6371;
   var dLat = deg2rad(lat2 - lat1);
   var dLng = deg2rad(lng2 - lng1);
   var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
   var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
   var d = R * c;
   return d;
}

export function getOS() {
   const platform = navigator.platform;
   const userAgent = navigator.userAgent;
   let os = "Unknown";

   if (platform.startsWith("Win")) {
      os = "Windows";
   } else if (/Android/.test(userAgent)) {
      os = "Android";
   } else if (/iPhone|iPad|iPod/.test(userAgent)) {
      os = "iOS";
   } else if (platform.startsWith("Mac")) {
      os = "MacOS";
   } else if (platform.startsWith("X11")) {
      os = "UNIX";
   } else if (platform.startsWith("Linux")) {
      if (/Android/.test(userAgent)) {
         os = "Android";
      } else {
         os = "Linux";
      }
   }

   return os;
}

export function redirectToMobileApp(os) {
   if (projectConfig?.hideMobileStoreRedirect) return;

   if (os === "Android" && projectConfig?.mobileApp?.android) {
      window.open(projectConfig.mobileApp.android, "_blank");
   } else if (
      os === "iOS" &&
      projectConfig?.mobileApp?.ios &&
      projectConfig?.mobileApp?.iosAppStore
   ) {
      window.open(projectConfig.mobileApp.ios, "_blank");

      setTimeout(() => {
         window.open(projectConfig.mobileApp.iosAppStore, "_blank");
      }, 10000);
   }
}
export function mobileStartFlutterActionByUrl(functionName, parameters) {
   try {
      if (window.mobileApp) {
         window.mobileApp.postMessage(
            JSON.stringify({
               functionName: functionName,
               parameters: parameters,
            }),
         );
      }
   } catch (error) {
      console.log(error);
   }
}

// This function compares objects, but if one of them has got parameter that second-one hasn't it skips this parameter.
// Examples: { one: 1, two: 2 } != { one: 1, two: "3 "}, but { one: 1 } == { one: 1, two: 3 }
export const compareObjects = (object1, object2) => {
   const isObject = (object) => {
      return object != null && typeof object === "object";
   };

   const keys = Object.keys(object1);
   for (const key of keys) {
      let val1;
      let val2;
      val1 = object1[key];
      if (val1?.id) {
         val2 = object2.find((elem) => elem?.id == val1?.id);
      } else {
         val2 = object2?.[key];
      }
      if (object2?.[key] == undefined || object1?.[key] == undefined) continue;
      if (Array.isArray(object1?.[key])) {
         if (object1[key].length != object2[key]?.length) {
            return false;
         }
      }
      const areObjects = isObject(val1) && isObject(val2);
      if ((areObjects && !compareObjects(val1, val2)) || (!areObjects && val1 !== val2)) {
         return false;
      }
   }
   return true;
};

export function isMobile() {
   let check = false;
   (function (a) {
      if (
         /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a,
         ) ||
         /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4),
         )
      )
         check = true;
   })(navigator.userAgent || navigator.vendor || window.opera);
   return check;
}

export function exportToCsv(stateCols, stateRows) {
   let cols = [];
   stateCols.forEach((col) => {
      if (col.fixed !== "left") {
         cols.push(col.dataIndex);
      }
   });
   let rows = [cols];
   if (stateRows) {
      stateRows.forEach((row) => {
         let csvRow = [];
         cols.forEach((col) => {
            if (col !== "action") {
               let text = "";
               if (row[col] && typeof row[col] != "object") {
                  text = row[col].toString();
               } else if (row[col] && row[col].value && typeof row[col] == "object") {
                  text = row[col].value.toString();
               }
               csvRow.push(text);
            }
         });
         rows.push(csvRow);
      });
   }
   return rows;
}
export function getElementHeight(id) {
   let element = document.getElementById(id);
   let height = 0;
   if (element) {
      height = element.offsetHeight;
   }
   return height;
}
export function getButtonsOffsetTop() {
   let offset = 0;
   let element = document.getElementById("message-button-nav");
   if (
      element &&
      element.parentElement &&
      element.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement
   ) {
      offset = element.parentElement.parentElement.parentElement.offsetTop;
   }
   return offset;
}
export function getScreenHeight() {
   let height = 0;
   height =
      window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
   return height;
}
export function makeElementScrollableFullYScreenSize(id) {
   let element = document.getElementById(id);
   let navHeight = getElementHeight("cloud-nav");
   let messageNavHeight = getElementHeight("message-button-nav");
   let screenHeight = getScreenHeight();
   let offsetTop = getButtonsOffsetTop();
   let messageBoxHeight = screenHeight - messageNavHeight - offsetTop - 48 + "px";
   if (element && navHeight > 0 && messageNavHeight > 0) {
      element.style.height = messageBoxHeight;
      element.style.maxHeight = messageBoxHeight;
   }
}
export function addTimes(startTime, endTime) {
   let now = moment().format("YYYY-MM-DD");
   let date1 = moment(`${now}T${startTime}`);
   let hours = +endTime.split(":")[0];
   let minutes = startTime.split(":")[1];
   let date = date1.add(hours, "hours").format("HH:MM");
   date = date.substr(0, 3) + minutes;
   return date;
}
export function scrollElementBottom(elementId) {
   const element = document.getElementById(elementId);
   if (element) {
      element.scrollTop = element.scrollHeight;
   }
}
export function isStringAnHTML(stringValue) {
   if (stringValue.includes("</")) {
      return true;
   } else {
      return false;
   }
}

window.addEventListener("resize", () => {
   makeElementScrollableFullYScreenSize("scroll-y-message");
});
window.fillLastClickedInput = function (text) {
   let elements = document.getElementsByClassName("last-clicked");
   let nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value",
   ).set;
   const triggerEvent = (element) => {
      const inputEventListener = () => {
         element.classList.remove("fill-clicked-input");
         element.removeEventListener("input", inputEventListener);
      };
      nativeInputValueSetter.call(element, text);
      let ev2 = new Event("input", { bubbles: true });
      window.addEventListener("input", inputEventListener);
      element.classList.add("fill-clicked-input");
      element.dispatchEvent(ev2);
   };

   if (elements && elements.length === 1) {
      triggerEvent(elements[0]);
   } else if (elements && elements.length === 2) {
      elements.map((element) => element.classList.contains("grid-cell") && triggerEvent(element));
   }
};
window.fillInputById = function (text, id) {
   let element = document.getElementById(id);
   let nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value",
   ).set;
   const triggerEvent = (element) => {
      const inputEventListener = () => {
         element.removeEventListener("input", inputEventListener);
      };
      nativeInputValueSetter.call(element, text);
      let ev2 = new Event("input", { bubbles: true });
      window.addEventListener("input", inputEventListener);
      element.dispatchEvent(ev2);
   };
   if (element) {
      triggerEvent(element);
   }
};
window.clickButtonById = function (id) {
   let element = document.getElementById(id);
   if (element) {
      element.click();
   }
};

window.dev = function () {
   window.devLogged = true;
   window.dispatchEvent(new Event("devLoggedChange"));
   const formItems = document.querySelectorAll('[style*="display:none"], [style*="display: none"]');
   formItems.forEach((element) => {
      element.setAttribute("data-dev-prev-style", element.getAttribute("style") || "");
      element.style.display = "";
      element.style.opacity = "0.5";
      element.classList.add("dev-modified");
   });

   document.querySelectorAll(".field-container").forEach((element) => {
      element.setAttribute("data-dev-prev-style", element.getAttribute("style") || "");
      element.style.visibility = "visible";
      element.style.position = "relative";
      element.style.opacity = "0.5";
      element.classList.add("dev-modified");
   });

   Array.from(document.getElementsByClassName("dev-info")).forEach((element) => {
      element.setAttribute("data-dev-prev-style", element.getAttribute("style") || "");
      element.style.display = "block";
      element.classList.add("dev-modified");
   });

   Array.from(document.getElementsByClassName("fieldStyle--hidden")).forEach((element) => {
      element.setAttribute("data-dev-prev-style", element.getAttribute("style") || "");
      element.style.display = "block";
      element.classList.add("dev-show");
      element.classList.add("dev-modified");
   });
};

window.unDev = function () {
   window.devLogged = false;
   window.dispatchEvent(new Event("devLoggedChange"));
   document.querySelectorAll("[data-dev-prev-style]").forEach((element) => {
      const prev = element.getAttribute("data-dev-prev-style") || "";
      if (prev) {
         element.setAttribute("style", prev);
      } else {
         element.removeAttribute("style");
      }
      element.removeAttribute("data-dev-prev-style");
      element.classList.remove("dev-modified");
   });

   document.querySelectorAll(".field-container").forEach((element) => {
      const prev = element.getAttribute("data-dev-prev-style") || "";
      if (prev) {
         element.setAttribute("style", prev);
      } else {
         element.style.visibility = "";
         element.style.position = "";
         element.style.opacity = "";
      }
      element.removeAttribute("data-dev-prev-style");
      element.classList.remove("dev-modified");
   });

   Array.from(document.getElementsByClassName("dev-info")).forEach((element) => {
      element.style.display = "none";
      element.classList.remove("dev-modified");
   });

   Array.from(document.getElementsByClassName("fieldStyle--hidden")).forEach((element) => {
      element.style.display = "none";
      element.classList.remove("dev-show");
      element.classList.remove("dev-modified");
   });
};

window.minimizeChat = function (toggle) {
   // Couldn't hide chat modal with redux because it's element is not available from code
   const chatModal =
      document.getElementById("cloud-chat")?.parentElement?.parentElement?.parentElement;
   if (chatModal && toggle === false) {
      chatModal.style.opacity = "0"; // chat is hidding faster with this line
      chatModal.style.visibility = "hidden";
      chatModal.style.pointerEvents = "none";
   } else if (chatModal && toggle === true) {
      chatModal.style.opacity = "1"; // chat is hidding faster with this line
      chatModal.style.visibility = "visible";
      chatModal.style.pointerEvents = "auto";
   }
};

export const addCustomStyleToElement = ({ style }, boolean, width) => {
   const boardPanel = document.getElementsByClassName("ant-tabs-tabpane-active")[0];

   if (boolean && width < TAB_SIZE) {
      if (boardPanel) boardPanel.style.paddingBottom = "40px";
      style.position = "fixed";
      style.zIndex = "999";
      style.bottom = "0px";
      style.backgroundColor = "white";
      style.width = "100%";
      style.left = "0px";
      style.top = "";
      style.color = "#767676";
      style.paddingTop = "10px";
      style.paddingBottom = "5px";
      style.paddingLeft = "10px";
      style.paddingRight = "10px";
      style.boxShadow = "0px 0px 1px rgba(0,0,0,0.1)";
      style.display = "flex";
      style.justifyContent = "center";
   } else {
      if (boardPanel) boardPanel.style.paddingBottom = "10px";
      style.position = "relative";
      style.bottom = "";
      style.top = "0px";
      style.backgroundColor = "transparent";
      style.width = "";
      style.left = "";
      style.zIndex = "";
      style.paddingBottom = "0px";
      style.paddingTop = "0px";
      style.paddingLeft = "0px";
      style.paddingRight = "0px";
      style.boxShadow = "";
      style.display = "";
   }
};

export const isBP2CloudOrCloudQA = () => {
   if (window.location.hostname === BP2_CLOUD || window.location.hostname === BP2_CLOUD_QA)
      return true;
   return false;
};

export const isHoppy = () => {
   if (window.location.hostname === HOPPY) return true;
   return false;
};

export const isEqual = () => {
   if (window.location.hostname === HOMEDEAL) return true;
   return false;
};

export const isGabinet = () => {
   if (window.location.hostname === GABINET) return true;
   return false;
};

export const isHoppyOrGamification = () => {
   if (window.location.hostname === CP_GAMIFICATION || window.location.hostname === HOPPY)
      return true;
   return false;
};

export const isAri = () => {
   if (window.location.hostname === ARI) return true;
   return false;
};

export const isCzg = () => {
   if (
      window.location.hostname === CZG ||
      window.location.hostname === CZG_QA ||
      window.location.hostname.includes("fotoevent")
   )
      return true;
   return false;
};
export const isApLog = () => {
   if (window.location.hostname === ETRACON) return true;
   return false;
};

export const isPflegePower = () => {
   if (window.location.hostname === PFLEGEPOWER) return true;
   return false;
};

export const isInSonelliGroup = (companies) => {
   if (companies) return companies.some((company) => company.name === "_Sonelli Group");
};

export const isInBpowerGroup = (companies) => {
   if (companies) return companies.some((company) => company.name === "Bpower2 sp. z o.o.");
};

export const isMultimodus = () => {
   if (window.location.hostname.includes("multimodus")) {
      return true;
   }
   return false;
};

export const isActivePublicUser = () => {
   if (localStorage.getItem("isPublicUserLogged") || localStorage.getItem("publicID")) {
      return true;
   } else {
      return false;
   }
};

export const isOwnerOrModerator = (role) => {
   return role === "OWNER" || role === "MODERATOR";
};

export const isBgk = () => {
   if (
      window.location.hostname.includes("bgk") ||
      window.location.hostname.includes("bpowercloud-dev.bank.com.pl")
   ) {
      return true;
   }
   return false;
};

export const isBpower2 = (companies) => {
   if (companies) return companies.some((company) => company.name === "Bpower2 sp. z o.o.");
   return false;
};

export const isCarlsbergUser = (authUser) => {
   return authUser?.companies?.[0]?.name?.includes("Carlsberg");
};

export const isCpAdmin = (authUser) => {
   if (
      authUser?.login === "all_akquinet" ||
      authUser?.login === "zall_akquinet" ||
      authUser?.login === "zall_admin4"
   )
      return true;
   return false;
};

export const getWidgetName = (widget) => {
   let widgetName = widget.id;
   if (widget.name === "list") {
      if (widget.listWidgetSeries.length === 1) {
         widgetName = `List - ${widget.listWidgetSeries[0].listId}`;
      } else {
         widgetName = "List";
      }
   } else if (widget.name === "productItem") {
      widgetName = `Product List${widget.mainTitle ? " - " + widget.mainTitle : ""}`;
   } else if (widget.name === "advertisementList") {
      widgetName = `Advertisement List${widget.title ? " - " + widget.title : ""}`;
   } else if (widget.name === "newsletterList") {
      widgetName = `Newsletter List${widget.title ? " - " + widget.title : ""}`;
   } else if (widget.name === "informationList") {
      widgetName = `Newsletter List${widget.title ? " - " + widget.title : ""}`;
   } else if (widget.name === "note") {
      widgetName = `Note${widget.noteTitle ? " - " + widget.noteTitle : ""}`;
   } else if (widget.name === "button") {
      widgetName = `Button${widget.btnTitle ? " - " + widget.btnTitle : ""}`;
   } else if (widget.name === "calendar") {
      widgetName = `Calendar${widget.calendarId ? " - " + widget.calendarId : ""}`;
   } else if (widget.name === "formV2" || widget.name === "form") {
      widgetName = `Form${widget.formId ? " - " + widget.formId : ""}`;
   } else if (widget.name === "kanban") {
      widgetName = "Kanban";
   }
   return widgetName;
};

// Function to generate a connection link
function generateConnectionLink(connection) {
   try {
      // Extract necessary values from the data

      let boardId = connection?.slaveBoardId
         ? connection?.slaveBoardId
         : connection?.data[0]?.slaveBoardId;
      let urlSheetId = connection?.redirectSheetId
         ? connection.redirectSheetId
         : connection?.data[0]?.slaveSheetId;
      // Create a new URL for the connections link
      const connectionsLink = new URL(`/boards/${boardId}/${urlSheetId}`, window.location.origin);

      // Set the search parameters for the connections link
      const params = {
         connectionsData: JSON.stringify(connection.data),
      };
      connectionsLink.search = new URLSearchParams(params);

      // Return the generated connections link
      return connectionsLink;
   } catch {
      return null;
   }
}

const processAction = (action, widgetConnections, listId = "") => {
   // skip actions without cloudConnections
   if (!listId.length && !action.cloudConnections) return;

   // find all connections matching action by actionButtonId
   // IMPORTANT: we only match by actionButtonId, as connection.id should not equal action.id
   const matchingConnections = widgetConnections.filter((conn) => {
      return String(conn.actionButtonId) === String(action.id);
   });

   if (matchingConnections.length === 0) {
      return;
   }

   // exactly one connection found - use it directly
   if (matchingConnections.length === 1) {
      action.connectionsLink = generateConnectionLink(matchingConnections[0]);
      return;
   }

   // multiple connections found - this should not happen
   if (matchingConnections.length > 1) {
      throw new Error(
         `Multiple connections found for action button ${action.id}. Expected exactly one connection.`,
      );
   }
};

// Function to add connections to action buttons
export const addConnectionsToActionButtons = (
   allConnections,
   actions,
   widgetId,
   listId = "",
   intl,
) => {
   try {
      // Filter the widget connections to only those belonging to the current widget
      const widgetConnections = allConnections?.filter(
         (connection) => connection.widgetId === widgetId,
      );
      const nestedList = actions?.some((el) => Array.isArray(el));
      if (!Array.isArray(actions)) {
         return;
      } else if (nestedList) {
         actions.forEach((group) => {
            if (!Array.isArray(group)) return;
            group.forEach((action) => processAction(action, widgetConnections, listId));
         });
      } else {
         actions.forEach((action) => processAction(action, widgetConnections, listId));
      }

      return actions;
   } catch (error) {
      Message.error(intl.formatMessage({ id: "addConnectionsToActionButtons.error" }));
      return actions;
   }
};

export const addRowValuesToConnection = (url, rowValues, isLowerCase) => {
   try {
      const connectionsData = JSON.parse(
         decodeURIComponent(url.searchParams.get("connectionsData")),
      );

      if (!Array.isArray(connectionsData)) return url.href;

      const newData = connectionsData.map((connection) => {
         let columnValue;
         if (isLowerCase) {
            columnValue = rowValues[connection.columnToGetValueFrom.toLowerCase()];
         } else {
            columnValue = rowValues[connection.columnToGetValueFrom];
         }

         let value = typeof columnValue === "object" ? columnValue.value : columnValue;
         if (value.includes("/")) {
            value = "b64:" + encode(value);
         }

         return {
            slaveWidgetId: connection.slaveWidgetId,
            columnToFilter: connection.columnToFilter,
            value,
         };
      });

      url.searchParams.set("connectionsData", encodeURIComponent(JSON.stringify(newData)));

      return url.href;
   } catch (err) {
      console.log("Error in adding column value to filter url", err);
      return url.href;
   }
};

export const getConnectionData = (widgetId) => {
   try {
      const urlParams = new URLSearchParams(window.location.search);

      let connectionsData = JSON.parse(decodeURIComponent(urlParams.get("connectionsData")));
      if (Array.isArray(connectionsData)) {
         let widgetConnection = connectionsData.find(
            (connection) => connection.slaveWidgetId === widgetId,
         );

         if (widgetConnection) {
            if (widgetConnection.columnToFilter) {
               return { [widgetConnection.columnToFilter]: widgetConnection.value };
            } else {
               return widgetConnection.value;
            }
         }
      }
   } catch {
      return undefined;
   }
};

export const setCssVariables = () => {
   const themeVariables = projectConfig?.cssVariables;
   const variablesKeys = Object.keys(themeVariables);
   const root = document.querySelector(":root");

   if (root && variablesKeys?.length) {
      variablesKeys.forEach((variableName) =>
         root.style.setProperty(variableName, themeVariables[variableName]),
      );
   }
};

export const updateBoards = async (intl) => {
   const newBoards = (await getUserWithBoards())?.data?.boards;
   if (newBoards) {
      const newBoardsWithIcons = await setBoardsIconLinks(newBoards);

      if (newBoardsWithIcons) {
         store.dispatch(setUserBoards(newBoardsWithIcons));
         Message.destroy();
         Message.success(intl.formatMessage({ id: "global.done" }));
      }
   } else {
      Message.destroy();
      Message.error(intl.formatMessage({ id: "global.error" }));
   }
};

export const getTranslationsInProperForm = async (language) => {
   return getTranslation(language)
      .then((res) => {
         const translations = res.data;
         if (!Array.isArray(translations)) {
            throw new Error(
               `Expected translations array from service, got ${typeof translations}: ${JSON.stringify(translations)?.slice(0, 100)}`,
            );
         }
         return translations.reduce((acc, { langKey, value }) => {
            acc[langKey] = value;
            return acc;
         }, {});
      })
      .catch((err) => {
         console.error("Error in getting translations");
         throw err;
      });
};
export const convertGmailFolderName = (folder) => {
   const nameWithoutCategory = folder.replaceAll("CATEGORY_", "");
   const firstLetter = nameWithoutCategory.charAt(0).toUpperCase();
   const restOfString = nameWithoutCategory.slice(1).toLowerCase();
   return firstLetter + restOfString;
};
export const updateTranslationsUsage = async (intl, withoutSuccessMessage) => {
   try {
      const updatedTranslations = await getTranslationsInProperForm(
         store?.getState()?.settings?.locale,
      );

      if (!updatedTranslations) return;
      store.dispatch(setTranslations(updatedTranslations));

      if (withoutSuccessMessage) return;
      Message.destroy();
      Message.success(intl.formatMessage({ id: "global.done" }));
   } catch (err) {
      console.log(err);
      Message.destroy();
      Message.error(
         intl.formatMessage({
            id: "translations.errorInUpdatingTranslations",
         }),
      );
   }
};

/**
 * Board format: { key, category, values: { pl, en, ... } }
 * Service format: { langKey, category, translations: [{ language, value, scope }] }
 */
export const syncBoardTranslationsToService = async (boardTranslations, allLanguages) => {
   if (!boardTranslations?.length || !allLanguages?.length) return;

   const raw = store.getState().translations.translations;
   const existingTranslations = Array.isArray(raw) ? {} : (raw ?? {});

   const entries = boardTranslations
      .filter((t) => t.key && t.values)
      .map((t) => {
         const serviceData = {
            langKey: t.key,
            category: t.category,
            translations: allLanguages
               .filter(({ language }) => t.values[language] != null)
               .map(({ language }) => ({
                  language,
                  value: t.values[language],
                  scope: "__default",
               })),
         };
         const isEdit = t.key in existingTranslations;
         return {
            key: t.key,
            category: t.category,
            fn: isEdit ? "editTranslations" : "postNewTranslation",
            promise: isEdit ? editTranslations(serviceData) : postNewTranslation(serviceData),
         };
      });

   const results = await Promise.allSettled(entries.map((e) => e.promise));

   results.forEach((result, i) => {
      if (result.status === "rejected") {
         const { key, category, fn } = entries[i];
         console.error(
            `Translation sync failed [${fn}] key="${key}" category="${category}":`,
            result.reason,
         );
      }
   });

   return results;
};

export const changeTranslationRecordToRequestData = (record) => {
   // Right now there only EN and PL translations handled. If you need more, add them to languages object;
   const { langKey, category, translations } = record;
   const languages = store?.getState()?.settings?.allLanguages?.map(({ language }) => language);

   const allTranslations = languages
      ?.filter((lang) => !!record[lang])
      ?.map((lang) => ({
         id: translations
            ? translations.find((translation) => translation.language === lang)?.id
            : null,
         language: lang,
         value: record[lang],
         scope: record.scope?.value ?? "__default",
      }));

   return { category, langKey, translations: allTranslations };
};

export const getSearchParams = (filterValues) => {
   try {
      const attributes = Object.keys(filterValues);

      const searchParams = {};
      const listOfModels = attributes.map((attribute) => attribute.split(".")?.[0]);

      listOfModels.forEach((model) => {
         const modelObject = {};

         attributes.forEach((attribute) => {
            if (attribute.includes(model)) {
               modelObject[attribute.split(".")?.[1]] = filterValues[attribute];
            }
         });

         searchParams[model] = modelObject;
      });
      return searchParams;
   } catch (err) {
      // If there is problem with filterValues, we return empty object to allow sending request even without filtering.
      return {};
   }
};

export const showTitle = (key, name, data) => {
   const lang = store?.getState()?.settings?.locale;
   let isTranslations = false;
   data?.translations &&
      data?.translations.filter((translation) => {
         if (
            translation?.key === key &&
            translation?.values.hasOwnProperty(lang) &&
            translation?.values[lang] !== ""
         ) {
            return (isTranslations = true);
         }
      });
   if (!isTranslations) {
      return name;
   } else if (isTranslations) {
      return <IntlMessages id={key} />;
   }
};

export const createShortGUID = (name, id) => {
   return `${name}.${id}.${Math.random().toString(36).substring(6)}`;
};

export const isShortGUID = (value) => {
   const regex = /^[a-zA-Z0-9_-]+\.\d+\.[a-z0-9]+$/;
   return regex.test(value);
};

/**
 * Generates random string key in format: prefix-xxxxxxxxxxx-xxxxxxwxxxx
 * @param {string} [prefixValue] - prefix in key
 * @returns - unique key
 */
export const generateGUID = (prefixValue) => {
   const prefix = `${prefixValue}-` || "";
   const GUID = `${prefix}${Math.random().toString(36)}-${Math.random().toString(36)}`;
   return GUID.replaceAll("0.", "");
};

export const isDataIdFromPHP = (id) => {
   const isFromPhp = Number.isInteger(+id) && id.length < 10;
   return isFromPhp;
};

export const showName = (lang, key, data) => {
   const translation = data?.translations?.find((t) => t.key === key);
   return translation?.values[lang] ?? "";
};

export const getMemberId = (board) => {
   const userId = store?.getState()?.auth?.authUser?.id;
   const memberId = board.members.find((memberInfo) => memberInfo.member.id === userId)?.id;

   return memberId;
};

export const parseMailContent = (textPlain, textHtml) => {
   const dataToDecode = textHtml ? textHtml : textPlain;
   const dataType = textHtml ? "textHtml" : "textPlain";
   const decodedContentElement = {};
   try {
      decodedContentElement.content = decode(dataToDecode);
   } catch {
      decodedContentElement.content = "Content decode error!";
   }
   decodedContentElement.type = dataType;
   return decodedContentElement;
};

export const transformFiltersForRequest = (filters) => {
   if (!Array.isArray(filters)) {
      return {
         filters: filters ?? {},
         strictFilters: [],
      };
   }

   return filters.reduce(
      (acc, { columnTechname, value, isStrict }) => {
         if (!columnTechname) return acc;

         acc.filters[columnTechname] = value;

         if (String(isStrict) === "1") {
            acc.strictFilters.push(String(columnTechname));
         }

         return acc;
      },
      { filters: {}, strictFilters: [] },
   );
};

export const isUrlImage = (url) => {
   const lcURL = url.toLowerCase();
   if (
      lcURL.includes(".png") ||
      lcURL.includes(".jpg") ||
      lcURL.includes(".jpeg") ||
      lcURL.includes(".gif") ||
      lcURL.includes(".svg")
   ) {
      return true;
   } else {
      return false;
   }
};

export const handleGoogleDriveLink = (action, url) => {
   const match = url.split("d/")?.[1]?.match(/(.*)(?=\/view)/g);
   const id = match ? match[0] : "";

   return `https://drive.google.com/uc?export=${action}&id=${id}`;
};

export const handlePhotoColumn = (column) => {
   if (typeof column === "string" && /^(https?):\/\/[^\s/$.?#][^\s]*$/.test(column)) {
      return column;
   } else if (typeof column === "object") {
      if (column.type === "SERVER") return column?.altUrl ?? column?.altUrl1 ?? column?.fileUrl;
      return handleGoogleDriveLink("view", column?.altUrl ?? column?.altUrl1 ?? column?.fileUrl);
   } else {
      return "badUrl";
   }
};

export const hexToRGBA = (hex, alpha) => {
   const r = parseInt(hex.slice(1, 3), 16);
   const g = parseInt(hex.slice(3, 5), 16);
   const b = parseInt(hex.slice(5, 7), 16);
   return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const mapFormChangelogObject = (changelog, encodeData = true) => {
   if (!changelog) return {};
   const compressedChangelog = {};
   Object.keys(changelog).forEach((key) => {
      if (key && key !== "undefined") {
         const fieldChangelog = changelog[key];
         if (fieldChangelog.label) {
            compressedChangelog[key] = fieldChangelog;
         }
      }
   });
   let changelogBase;
   try {
      changelogBase = encodeData
         ? encode(JSON.stringify(compressedChangelog))
         : compressedChangelog;
   } catch {
      changelogBase = {};
      console.log("Changelog error");
   }
   return changelogBase;
};

export const updateWidgetCache = (widgetId, widgetName, widgetSettings) => {
   // I need to put this if because previously widgetCache was a object
   store.dispatch(
      setWidgetCache(
         !Array.isArray(store?.getState()?.widgetCache)
            ? [{ widgetId: widgetId, widgetType: widgetName, settings: widgetSettings }]
            : [
                 ...store?.getState()?.widgetCache?.filter((widget) => widget.widgetId != widgetId),
                 { widgetId: widgetId, widgetType: widgetName, settings: widgetSettings },
              ],
      ),
   );
};

export const handleTemplateAlert = (techName, textValue) => {
   const templateAlertContainer = document.getElementById(`tmpl-alert-${techName}`);
   const templateAlertText = document.getElementById(`tmpl-alert-${techName}-text`);
   if (!templateAlertText || !templateAlertContainer) return;
   templateAlertContainer.style.display = textValue ? "flex" : "none";
   templateAlertText.textContent = textValue || "";
};

export const createElementFromHTML = (htmlString) => {
   var div = document.createElement("div");
   div.innerHTML = htmlString.trim();
   return div.firstChild;
};

export const getNameOfDayOfWeek = (date) => {
   //date as string
   //In polish version we get a name of week with lowercase as first letter, so we need to change that manually
   const dayOfWeek = moment(date).locale(store?.getState()?.settings.locale).format("dddd");
   return dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);
};

export const getBase64StringFromDataURL = (dataURL) =>
   dataURL.replace("data:", "").replace(/^.+,/, "");

export const validateTranslations = (settings) => {
   if (window.location.hostname === "localhost" || window.location.hostname === "qa.bp2.cloud") {
      return true;
   }

   const requiredLanguages = ["en", "pl"];
   const allTranslationsPresent = requiredLanguages.every((lang) => {
      return settings[`name${lang}`] && settings[`name${lang}`].trim() !== "";
   });

   return allTranslationsPresent;
};

export const getAllFieldsWithAlerts = (input) => {
   if (!input) return [];
   if (input.forms_data?.tab) return getAllFieldsWithAlerts(input.forms_data.tab);
   if (Array.isArray(input))
      return input.flatMap((tab) => getAllFieldsWithAlerts(tab?.elements ?? {}));
   if (input.elements) return getAllFieldsWithAlerts(input.elements);
   return Object.values(input)
      .filter((el) => el?.hasAlert)
      .map((el) => ({ id: el.id, techName: el.tech_name }));
};
export const addPrefixToAllObjectKeys = (obj, prefix) => {
   return JSON.parse(
      JSON.stringify(obj).replace(/(?<=[{,]{1}\s*")(.+?)(?="\s*:)/gim, `${prefix}$1`),
   );
};

export const isDataIdFromJava = (id) => {
   if (typeof id !== "string") return false;

   return id?.split("-")?.length > 2;
};

export const stringContainsOnly1Char = (str, ch) => {
   return !new RegExp("[^s" + ch + "]").test(str);
};

export const urlHasJavaRecordId = (url) => {
   let urlHasJavaDataId = false;
   if (url?.includes("recordId")) {
      const dataId = url.split("recordId=")[1]?.split("&")[0];
      urlHasJavaDataId = isDataIdFromJava(dataId);
   } else if (url?.includes("dataId")) {
      const dataId = url.split("dataId=")[1]?.split("&")[0];
      urlHasJavaDataId = isDataIdFromJava(dataId);
   }
   return urlHasJavaDataId;
};

export const getDate = () => {
   const date = new Date();

   const day = String(date.getDate()).padStart(2, "0");
   const month = String(date.getMonth() + 1).padStart(2, "0");
   const year = date.getFullYear();

   return `${day}.${month}.${year}`;
};

export const getTime = () => {
   const date = new Date();

   const hours = String(date.getHours()).padStart(2, "0");
   const minutes = String(date.getMinutes()).padStart(2, "0");

   return `${hours}:${minutes}`;
};

export const setBoardsIconLinks = async (boards) => {
   try {
      await Promise.allSettled(
         boards.map(async (board) => {
            if (board.boardIconId) {
               const res = await getFile(board.boardIconId);
               board.iconLink = res.data;
            }
         }),
      );
      return boards;
   } catch (err) {
      console.log("Problem with fetching icons for boards", err);
   }
};
